import React, { useEffect, useState } from "react";
import { Row, Col, Container, Form, Button, Carousel, Spinner, Image } from "react-bootstrap";
import godrejDarkLogo from "../../icons/godrej-logo-dark.svg"
import { LOGIN_GODREJ_EMPLOYEE, LOGIN_CUSTOMER } from "../../utils/constant";
import { useMsal } from "@azure/msal-react";
import { compose } from "redux";
import { loginRequest } from "./authConfig";
import login1 from "../../icons/Login01.png"
import login2 from "../../icons/Login02.png"
import login3 from "../../icons/Login03.png"

import { extLoginRequest } from './authConfigExternal';

const LoginPage = (props) => {
  const [userLoginType, setUserLoginType] = useState("");
  const [loading, setLoading] = useState(false);
  const { instance } = useMsal();

  let err = ""
  const [errorMessage, setErrorMessage] = useState(err ? err : "");

  useEffect(() => {
    const tmpLoginType = sessionStorage.getItem("LoginType");
    if (tmpLoginType === null) {
      sessionStorage.setItem("LoginType", "Godrej Employee");
      setUserLoginType("Godrej Employee");
    }
    else {
      setUserLoginType(tmpLoginType);
    }
  }, []);

  useEffect(() => {
    setErrorMessage(props.loginErrorMessage);
    if (props.loginErrorMessage) {
      const tmpLoginType = sessionStorage.getItem("LoginType");
      sessionStorage.clear();
      sessionStorage.setItem("LoginType", tmpLoginType);
    }

  }, [props.loginErrorMessage]);

  const loginFunction = async () => {
    setErrorMessage("");
    const tmpLoginType = sessionStorage.getItem("LoginType");
    if (tmpLoginType === LOGIN_GODREJ_EMPLOYEE || tmpLoginType === null) {
      instance.loginRedirect(loginRequest).catch(e => {
        console.log("error in login", e)
      });
    }
    else if (tmpLoginType === LOGIN_CUSTOMER) {
      instance.loginRedirect(extLoginRequest).catch(e => {
        console.log("error in login", e)
      });
    }

  };

  const onChangeLoginType = (e) => {
    sessionStorage.setItem("LoginType", e.target.value);
    setUserLoginType(e.target.value);
    window.location.href = "/";
  };

  return (
    <>
      {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
      <Container bsPrefix="login-container"  >
        <div className="login-page">
          <div className="login-header">
            <Image className="logo" src={godrejDarkLogo} alt="godrej logo" />
            <div className="login-header-text">Godrej Enterprises Group</div>
          </div>
          <Carousel>
            <Carousel.Item>
              <Image className="login-image" src={login1} alt="First slide" />
            </Carousel.Item>
            <Carousel.Item>
              <Image className="login-image" src={login2} alt="Second slide" />
            </Carousel.Item>
            <Carousel.Item>
              <Image className="login-image" src={login3} alt="Third slide" />
            </Carousel.Item>
          </Carousel>
          <div className="login-box">
            {errorMessage && (
              <div className="loginErrorDiv">
                <div className="loginErrorDivHeader">Login Failed</div>
                <div className="loginErrorDivBody">{errorMessage}</div>
              </div>
            )}
            <div className="login-logo text-start mb-3 mb-md-4">
              <div className="login-logo-title">Scrap Tender Management System</div>
            </div>
            <div className="mt-3 mt-md-4">
              <div className="LoginRightRadioDivTitle mb-2 mb-md-3">Select User Type</div>
              <div className="LoginRightRadioDiv">
                <div className="LoginRightRadioLabel">
                  <Form.Check
                    label={LOGIN_GODREJ_EMPLOYEE}
                    name="loginType"
                    type="radio"
                    onChange={(e) => {
                      setErrorMessage("");
                      onChangeLoginType(e);
                    }}
                    value={LOGIN_GODREJ_EMPLOYEE}
                    checked={userLoginType === LOGIN_GODREJ_EMPLOYEE}
                    className="login-form-check"
                  />
                </div>
                <div className="LoginRightRadioLabel">
                  <Form.Check
                    label={LOGIN_CUSTOMER}
                    name="loginType"
                    type="radio"
                    value={LOGIN_CUSTOMER}
                    checked={userLoginType === LOGIN_CUSTOMER}
                    className="login-form-check"
                    onChange={(e) => {
                      setErrorMessage("");
                      onChangeLoginType(e);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 mt-md-4">
              <Button variant="success"
                onClick={async () => {
                  await loginFunction();
                }}
                className="forgotButton"
              >
                Login
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
export default compose(LoginPage);
